import React, { useEffect, useId, useRef, useState } from "react";
import InputMask from "react-input-mask";

const InputDefault = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  disabled,
  mask,
  maxLength,
  onBlur,
  error,
  success,
  autoFocus,
  handleKeyDown,
  type = "text",
  step,            // ✅ NUEVO
  inputRefProp,    // ✅ NUEVO (ref externo)
}) => {
  const id = useId();
  const inputRef = useRef(null);

  const [isFocus, setIsFocus] = useState(false);
  const [inputWrapperStyle, setInputWrapperStyle] = useState();
  const [inputStyle, setInputStyle] = useState();
  const [inputLabelStyle, setInputLabelStyle] = useState();

  // ✅ une el ref interno + externo
  const setRefs = (node) => {
    inputRef.current = node;

    if (!inputRefProp) return;
    if (typeof inputRefProp === "function") inputRefProp(node);
    else inputRefProp.current = node;
  };

  useEffect(() => {
    const onDocClick = (event) => {
      setIsFocus(event?.target === inputRef.current);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  useEffect(() => {
    setInputWrapperStyle(`input-wrapper ${disabled ? "disabled" : ""} `);
    setInputLabelStyle(
      `poppins-regular-font ${value || isFocus ? "input-label-focused" : ""}`
    );
    setInputStyle(`poppins-regular-font ${onInputStatusStyle()}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, error, success, disabled, isFocus]);

  const onInputStatusStyle = () => {
    return ` ${error ? "input-error" : ""} ${value && success ? "input-success" : ""}`;
  };

  return (
    <div className={inputWrapperStyle}>
      {label && (
        <label htmlFor={id} className={inputLabelStyle}>
          {label}
        </label>
      )}

      {mask ? (
        <InputMask
          mask={mask}
          id={id}
          name={name}
          ref={setRefs} // ✅ ref unido
          className={inputStyle}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      ) : (
        <input
          id={id}
          name={name}
          ref={setRefs}       // ✅ ref unido
          className={inputStyle}
          type={type}
          step={step}         // ✅ step para time
          value={value}
          onChange={onChange}
          maxLength={maxLength || 100}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={handleKeyDown}
        />
      )}
    </div>
  );
};

export default InputDefault;